export default __webpack_public_path__ + "static/search-e439a7304ad3f90d8d8f362772df43d4.png";